import { useMemo } from "react";
import { useEmployeeKpis } from "@/hooks/queries/useEmployeeKpis";

interface EmployeesAnalyticsParams {
  from: string;
  to: string;
  basis: "accrual" | "cash";
}

export function useEmployeesAnalytics({ from, to, basis }: EmployeesAnalyticsParams) {
  const params = useMemo(() => ({ from, to, basis }), [basis, from, to]);
  const { data: rows = [], isLoading } = useEmployeeKpis(params);
  const topRows = useMemo(() => rows.slice(0, 10), [rows]);

  return { rows, topRows, isLoading };
}
